module.exports = __webpack_public_path__ + "img/gift-card.bb4e5fc0.jpg";